import React from 'react';
import { Empty } from 'antd';

interface EmptyStateProps {
    description?: React.ReactNode;
    /** Optional action button(s) shown under the description. */
    action?: React.ReactNode;
    /** Wrap in the standard dashed-border container (for page sections; tables don't need it). */
    bordered?: boolean;
}

/**
 * Standard empty state. Use inside Table via locale={{ emptyText: <EmptyState ... /> }}
 * or standalone (bordered) for empty page sections and card grids.
 */
const EmptyState: React.FC<EmptyStateProps> = ({ description = 'No data found', action, bordered = false }) => {
    const content = (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span className="text-muted-foreground">{description}</span>}>
            {action}
        </Empty>
    );
    if (!bordered) return content;
    return <div className="rounded-xl border-2 border-dashed border-border py-8">{content}</div>;
};

export default EmptyState;
